
export const fetchSummary = summary => ({
    type: 'FETCH_SUMMARY',
    summary
});

export const fetchStats = stats => ({
    type: 'FETCH_STATS',
    stats
});
